module.exports = __webpack_public_path__ + "qr_code_android_roc.8895e7c.png";